import { uiProgramSettingsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const UI_PROGRAM_SETTINGS_ACTION_TYPE = createNamedActions('uiProgramSettings', {
  GET_SETTINGS: 'GET_SETTINGS',
  EDIT_SETTINGS: 'EDIT_SETTINGS',
});

export const getUiProgramSettingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await uiProgramSettingsApi.getSettings(params);

  return dispatch({
    type: UI_PROGRAM_SETTINGS_ACTION_TYPE.GET_SETTINGS,
    payload: data,
  });
});

export const editUiProgramSettingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await uiProgramSettingsApi.editSettings(params);

  return dispatch({
    type: UI_PROGRAM_SETTINGS_ACTION_TYPE.EDIT_SETTINGS,
    payload: data,
  });
});
